module.exports = __webpack_public_path__ + "static/media/32.0aa9ba4b.webp";